import { useContext } from 'react';
import { UserSyncSettingsContext, type UserSyncSettingsContextValue } from './UserSyncSettingsContext';

/**
 * useUserSyncSettings - Access cached user sync settings
 *
 * Must be used within PrivateAppProvider. Throws error if used outside provider.
 *
 * @returns User sync settings context value (settings, isLoading)
 * @throws Error if used outside PrivateAppProvider
 *
 * @example
 * const { settings, isLoading } = useUserSyncSettings();
 * if (isLoading || !settings?.activeSyncProvider) return null;
 * // Use settings.activeSyncProvider
 */
export function useUserSyncSettings(): UserSyncSettingsContextValue {
  const context = useContext(UserSyncSettingsContext);
  if (!context) {
    throw new Error('useUserSyncSettings must be used within PrivateAppProvider');
  }
  return context;
}